import React, { Component } from 'react';
import OcLtInEx from './Paitent/OcLt-InEx.js';
import Levels from './Paitent/Levels.js';
import { firebaseRef } from './firebase.js';
import Indicator from './indicator';
import { Link, withRouter } from 'react-router-dom';
import Tried from './Paitent/Tried.js';
import Leftright from './Paitent/LeftRight.js';
import Abdadd from './Paitent/Abdadd.js';
import Profile from './Paitent/Profile.js';
import Sri from './Paitent/Sri.js';
import Stradegy from './Paitent/Stradegy.js';
import Buttons from './Paitent/Buttons.js';
import Historypatient from './Paitent/History.js';
import FaAngleUp from 'react-icons/lib/fa/angle-up';
import FaCog from 'react-icons/lib/fa/cog';
import Settings from './settings.js';
import Modal from 'react-modal';
import Userimage from './Paitent/userImage.js';
import FaEdit from 'react-icons/lib/fa/edit';

var names = [];
class Patient extends Component {
constructor(props){
  super(props);
  this.state = {
    focused: true,
    searched: false,
    user: '',
    doctorExists: true,
    userExists: true,
    loader: true,
    fname: '',
    lname: '',
    modal: false,
    ocltinex: true,
    profile: true,
    levels: true,
    tried: true,
    heel: true,
    adbAdd: true,
    leftright: true,
    userimage: true,
    editName: true,
    newName: '',
    editMessage: '',
    editSucces: false
  };
  this._logout = this._logout.bind(this);
  this._newpaitent = this._newpaitent.bind(this);
  this._handleChangeUsername = this._handleChangeUsername.bind(this);
  this._searchUser = this._searchUser.bind(this);
  this._settings = this._settings.bind(this);
  this.closeModal = this.closeModal.bind(this);
  this.deleteUser = this.deleteUser.bind(this);
  this._userguide = this._userguide.bind(this);
  this.editName = this.editName.bind(this);
  this.editNewName = this.editNewName.bind(this);
  this.saveNewName = this.saveNewName.bind(this);
}
  componentWillMount(){
    var that=this;
    firebaseRef.auth().onAuthStateChanged(function(user) {
  if (user) {

  } else {
    // No user is signed in.
    that.props.history.push("/");
  }
  });
  var userId = this.props.match.params.user;
  var doctor = this.props.match.params.doctor;
  var refMain = firebaseRef.database().ref('doctors/'+doctor);
  refMain.once('value', function(datasnapShot){
    if (!datasnapShot.exists()) {
      that.setState({ doctorExists: false });
    }
    });
  var refMainUser = firebaseRef.database().ref('doctors/'+doctor+'/users/'+userId);
  refMainUser.once('value', function(datasnapShot){
    if (!datasnapShot.exists()) {
      that.setState({ userExists: false, loader: false });
    }else{
      var value = datasnapShot.val();
      that.setState({ loader: false, fname: value.fname, lname: value.lname });
    }
    });
  }

  componentWillReceiveProps(newProps){
    window.location.reload();
  }

  _logout(){
    var that=this;
    firebaseRef.auth().signOut().then(function() {
      that.props.history.push("/");
  }).catch(function(error) {
    alert("An Errror acurred Please Try Agian" + error);
  });
  }

  _newpaitent(){
    this.props.history.push("/newuser");
  }

  _handleChangeUsername(event) {
    this.setState({user: event.target.value});
  }

  _searchUser(){
    this.setState({ searched: true });
    if (this.state.user === '') {
      this.setState({ searched: false });
      return false;
    }
     names = [];
    var that=this;
    var doctor = firebaseRef.auth().currentUser.uid;
    var refMain = firebaseRef.database().ref('doctors/'+doctor+'/users/');
    refMain.on('child_added', (datasnapShot) => {
      var Obj = datasnapShot.val();
      var fullName = Obj.fname.toLowerCase() +' '+ Obj.lname.toLowerCase();
      var fixedName = that.state.user.toLowerCase();
      if (fullName.includes(fixedName)) {
        var Name = Obj['fname'] +' '+ Obj['lname'];
        var button = {"name": Name, "key": datasnapShot.key, "doctor": doctor};
        names.push(button);
         //const listItems = names.map((d) => <li key={d.key}>{d.name}</li>);
        that.setState({ focused: false });
      }else{
        that.setState({ focused: false });
      }
    });
  }

  goToTop(){
    window.scrollTo(0, 0);
  }

  _settings(){
    this.setState({ modal: true });
  }

  closeModal(){
    this.setState({ modal: false });
  }

  componentDidMount(){
    var doctor = this.props.match.params.doctor;
    var that=this;
    var refMain = firebaseRef.database().ref('doctors/'+doctor+'/hide');
    refMain.on('child_added', function(datasnapShot){
      console.log(datasnapShot.key);
      switch (datasnapShot.key) {
      case 'ocltinex':
        that.setState({ ocltinex: false });
      break;
      case 'profile':
        that.setState({ profile: false });
      break;
      case 'userimage':
        that.setState({ userimage: false });
      break;
      case 'levels':
        that.setState({ levels: false });
      break;
      case 'tried':
        that.setState({ tried: false });
      break;
      case 'heel':
        that.setState({ heel: false });
      break;
      case 'adbAdd':
        that.setState({ adbAdd: false });
      break;
        default:

      }

    });
    refMain.on('child_removed', function(datasnapShot){
      switch (datasnapShot.key) {
      case 'ocltinex':
        that.setState({ ocltinex: true });
      break;
      case 'userimage':
        that.setState({ userimage: true });
      break;
      case 'profile':
        that.setState({ profile: true });
      break;
      case 'levels':
        that.setState({ levels: true });
      break;
      case 'tried':
        that.setState({ tried: true });
      break;
      case 'heel':
        that.setState({ heel: true });
      break;
      case 'adbAdd':
        that.setState({ adbAdd: true });
      break;
        default:

      }
    })
  }

  deleteUser(event){
    var user = event.target.value;
    var that=this;
    var doctor = firebaseRef.auth().currentUser.uid;
    var refMain = firebaseRef.database().ref('doctors/'+doctor+'/users/'+user);
    refMain.remove().then(function(){
      var index = names.map(function(e) { return e.key; }).indexOf(user);
      names.splice(index, 1);
      that.forceUpdate();
    }).catch(function(error){
      alert("Removing this user was unsuccesfull please try agian." + error);
    });
  }

  _userguide(){
    this.props.history.push("/userguide");
  }

  editName(){
    this.setState({
      editName: !this.state.editName
    });
    if (this.state.editName) {
      this.nameInput.focus();
    }
  }

  editNewName(event){
    var value = event.target.value;
    this.setState({
      newName: value
    })
  }

  saveNewName(){
    var value = this.state.newName;
    this.setState({ editMessage: '', editSucces: false });
    var that=this;
    if (/\s/.test(value)) {
    var fname = '';
    var lname = '';
    var split = value.split(" ");
    if (split.length == 3) {
      var fname = split[0];
      var lname = split[1] +' '+ split[2];
    }else{
      if (split.length > 2) {
        this.setState({ editMessage: 'You have too many whitespaces.' });
        return false;
      }else{
      var fname=split[0];
      var lname=split[1];
    }
  }
    var doctor = firebaseRef.auth().currentUser.uid;
    var userId = this.props.match.params.user;
    var refMain = firebaseRef.database().ref('doctors/'+doctor+'/users/'+userId);
    refMain.update({
      fname: fname,
      lname: lname
    }).then(function(){
        that.setState({ editName: true, editSucces: true });
    });
}else{
  this.setState({ editMessage: 'You didnt changed anything.' });
}
  }

  render() {
    return (
      <div id="main-container">
      <div id="header">
        <h2 className="header-title">Chirosystem</h2>
        <div>
          <input type="text" className="header-search" placeholder="Search Paitent..." ref="searchInput" onFocus={this._onFocus} onBlur={this._onBlur} value={this.state.user} onChange={this._handleChangeUsername}/>
          <input type="button" className="logout-button" value="Search" onClick={this._searchUser}/>
        </div>
        <div className="header-links">
          <button type="button" onClick={this._settings} className="logout-button" style={{width: 60}}><FaCog size={30}/></button>
          <Modal
          isOpen={this.state.modal}
          onRequestClose={this.closeModal}
          className="Modal-settings"
          contentLabel="Example Modal"
          >
          <Settings />
          </Modal>
          <button type="button" onClick={this._newpaitent} className="logout-button">New Paitent</button>
          <button type="button" onClick={this._logout} className="logout-button">Logout</button>
          <button type="button" onClick={this._userguide} className="logout-button">Guide</button>
        </div>
      </div>
      {this.state.searched ? (
        this.state.focused ? (
          <Indicator />
        ) : (
          names.length > 0 ? (
            <div>{names.map(d => (<div key={d.key} className="div-search-user"><Link to={`/patient/${d.doctor}/${d.key}`} className="button-search-user">{d.name}</Link><button type='button' className='delete-user' value={d.key} onClick={this.deleteUser}>Delete</button></div>))}</div>
          ) : (
            <div><h3>Theres no paitents under that name.</h3></div>
          )
        )


      ) : (
        this.state.loader ? (
          <Indicator />
        ) : (
        this.state.doctorExists && this.state.userExists ? (
        <div id="header-user-content">
          <div className="user-name"><div><input ref={(input) => { this.nameInput = input; }} type="text" defaultValue={this.state.fname +' '+ this.state.lname} className="name-input" readOnly={this.state.editName} onChange={this.editNewName}/>
          {this.state.editName ? (
            <button type="button" className="edit-user-name-button" onClick={this.editName}><FaEdit color="grey" size={30}/></button>
          ) : (
            <button type="button" className="edit-user-name-button save-edit" onClick={this.saveNewName}>Save</button>
          )}
          </div>
          {this.state.editSucces ? (
            <div style={{height: 50}}><p style={{color: 'green'}}>Succesfull!</p></div>
          ) : (
            <div style={{height: 50}}><p style={{color: 'red'}}>{this.state.editMessage}</p></div>
          )}
          </div>
          <div className="profile-oclt-container">
          {this.state.ocltinex ? (
            <OcLtInEx {...this.state} loader={this.didMountAll}/>

          ) : (
            <div></div>
          )}
          {this.state.userimage ? (
            <Userimage {...this.state} />
          ) : (
            <div></div>
          )}
          </div>
          <div id="under-ocltinex">
          {this.state.levels ? (
            <Levels {...this.state} loader={this.didMountAll}/>
          ) : (
            <div></div>
          )}

          <div id="near-levels">
          {this.state.tried ? (
            <Tried {...this.state}/>
          ) : (
            <div></div>
          )}
          {this.state.heel ? (
            <Leftright {...this.state}/>
          ) : (
            <div></div>
          )}
          {this.state.adbAdd ? (
            <Abdadd {...this.state}/>
          ) : (
            <div></div>
          )}
          {this.state.profile ? (
            <Profile />
          ) : (
            <div></div>
          )}
          </div>
          </div>
          <div id="stradegy-sri">
            <Sri {...this.state}/>
            <Stradegy {...this.state}/>
          </div>
          <div>
            <Buttons {...this.state}/>
            <Historypatient {...this.state}/>
          </div>
        </div>
      ): (
        <div align="center">
          <h3>Please search for a paitent or Add a new one.</h3>
        </div>
      )
      )
      )
      }
      <div className="click-to-top" onClick={this.goToTop}><FaAngleUp size={50} style={{marginTop: 0}}/></div>
      </div>
    );
  }
}

export default withRouter(Patient);



// WEBPACK FOOTER //
// ./src/routes/Patient.js